import { render, staticRenderFns } from "./updataAndview-physicalmodel.vue?vue&type=template&id=aa401e7c"
import script from "./updataAndview-physicalmodel.vue?vue&type=script&lang=js"
export * from "./updataAndview-physicalmodel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\GitWorkplace\\物联网\\tenda_iot_system\\node_modules\\_vue-hot-reload-api@2.3.4@vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aa401e7c')) {
      api.createRecord('aa401e7c', component.options)
    } else {
      api.reload('aa401e7c', component.options)
    }
    module.hot.accept("./updataAndview-physicalmodel.vue?vue&type=template&id=aa401e7c", function () {
      api.rerender('aa401e7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common-physical-model/updataAndview-physicalmodel.vue"
export default component.exports